import { Vector3, Euler, Quaternion } from 'three';

function CylinderLine({inPo1, inPo2}) {
    const start = new Vector3(inPo1[0], inPo1[1], inPo1[2]);
    const end = new Vector3(inPo2[0], inPo2[1], inPo2[2]);
    const midPoint = new Vector3().addVectors(start, end).divideScalar(2);
    const dir = new Vector3().subVectors(end, start).normalize();
    const length = start.distanceTo(end);

    return (
        <mesh position={midPoint} rotation={new Euler().setFromQuaternion(new Quaternion().setFromUnitVectors(new Vector3(0, 1, 0), dir))}>
            <cylinderGeometry args={[0.1, 0.1, length, 32]} />
            <meshStandardMaterial color="grey" />
        </mesh>
    );
}
export default CylinderLine;